import DatePickerFilter, { DatePickerFilterOption } from '../DatePicker';
import SearchInput from '../SearchInput';
import { TableFilterRow } from '../TableList';
import { IReportFiltersProps, ReportFilter } from './types';

export const ReportFilters = ({
  onPageChange,
  params
}: IReportFiltersProps): JSX.Element => {
  const filters: ReportFilter[] = [
    {
      id: 'created_from',
      value: (params['created_from'] as string) || '',
      label: 'Date From',
      useLabelForChip: true,
      options: {
        maxDate: (params['created_to'] as string) || ''
      }
    },
    {
      id: 'created_to',
      value: (params['created_to'] as string) || '',
      label: 'Date To',
      useLabelForChip: true,
      options: {
        minDate: (params['created_from'] as string) || ''
      }
    }
  ];

  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  const handleFilterChange = (
    change: Record<string, string | number | undefined>
  ) => {
    setTimeout(() => onPageChange(change), 500);
  };

  return (
    <TableFilterRow>
      <SearchInput
        value={(params.search as string) || ''}
        onSearch={handleSearch}
        placeholder={'Search for order number, employee names or emails'}
      />
      {filters.map((f) => {
        return (
          <span key={f.id}>
            <DatePickerFilter
              {...f}
              options={f.options as DatePickerFilterOption}
              onValueChange={handleFilterChange}
            />
          </span>
        );
      })}
    </TableFilterRow>
  );
};
